/**
 * Module dependencies.
 */

import { Control, FieldValues } from 'react-hook-form';
import { InputField } from 'app/components/atoms/forms/fields/input/input-field';
import { requiredRule } from 'app/core/utils/field-rules';
import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * `Props` type.
 */

type Props = {
  control: Control<FieldValues, any>;
  showOtp: boolean;
};

/**
 * Export `CoverflexConnector` component.
 *
 * Real Coverflex login: email + password, and — on an untrusted device — an SMS
 * OTP as a second step (mirrors the Edenred credentials → PIN flow). Only the
 * resulting refresh token is stored; the password is never persisted.
 */

export function CoverflexConnector({ control, showOtp }: Props): JSX.Element {
  const [translate] = useTranslation();

  return (
    <div className={'pt-8'}>
      <InputField
        control={control}
        disabled={showOtp}
        label={translate('common.labels.email')}
        name={'email'}
        rules={requiredRule(translate)}
      />

      <InputField
        control={control}
        disabled={showOtp}
        label={translate('common.labels.password')}
        name={'password'}
        rules={requiredRule(translate)}
        type={'password'}
      />

      {showOtp && (
        <InputField
          control={control}
          label={translate('bankAccounts.connect.wizard.coverflexOtpLabel')}
          name={'otp'}
          rules={requiredRule(translate)}
        />
      )}
    </div>
  );
}
